var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"panel"},[_c('p',{staticClass:"panel-heading"},[_vm._v("\n        Inquiry's\n    ")]),_vm._v(" "),_c('VuePerfectScrollbar',{staticClass:"scroll-area",attrs:{"settings":_vm.settings},on:{"ps-scroll-y":_vm.scrollHandle}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-441bfeb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Manager/Inquiry.vue
// module id = null
// module chunks = 